import * as React from 'react';

import { IGuestV2 } from 'data/entities/event/guest';
import { FormInput, FormInputTextArea, FormLabel, FormRow } from '../form/';

interface IGuestDetailsProps {
	admin: boolean;
	customerId: string;
	guest: IGuestV2;
	source: string;
	onChange: (guest: IGuestV2) => any;
}

export const GuestDetails = (props: IGuestDetailsProps) => {
	const [guest, setGuest] = React.useState(props.guest);
	const phoneAndMobileMatch = (guest.contact.phone ?? '') === (guest.contact.mobile ?? '');

	const onChange = (sub: string, key: string, value: any) => {
		const guestData = { ...guest };
		guestData[sub][key] = value;
		setGuest(guestData);
		props.onChange(guest);
	};

	return (
		<div className="booking-list__section">
			<h2>Guest details</h2>
			<FormRow>
				<FormLabel htmlFor="guest_name">Guest name</FormLabel>
				<FormInput
					value={(guest.contact || { name: '' }).name}
					onChange={(e) =>
						onChange('contact', 'name', e.target.value)
					}
					readOnly={!props.admin}
				/>
			</FormRow>
			<FormRow>
				<FormLabel htmlFor="guest_email">Guest email</FormLabel>
				<FormInput
					value={(guest.contact || { email: '' }).email}
					onChange={(e) =>
						onChange('contact', 'email', e.target.value)
					}
					readOnly={!props.admin}
				/>
			</FormRow>
			<FormRow>
				<section className="booking-list_side-by-side">
					{
						phoneAndMobileMatch ?
							<>
								<div>
									<FormLabel htmlFor="guest_mobile">
										Guest phone number
									</FormLabel>
									<FormInput
										value={(guest.contact || { phone: '' }).phone}
										onChange={(e) => {
											onChange('contact', 'mobile', e.target.value);
											onChange('contact', 'phone', e.target.value);
										}}
										readOnly={!props.admin}
									/>
								</div>

							</>
							:
							<>
								<div>
									<FormLabel htmlFor="guest_phonenum">
										Guest phone number
									</FormLabel>
									<FormInput
										value={(guest.contact || { phone: '' }).phone}
										onChange={(e) =>
											onChange('contact', 'phone', e.target.value)
										}
										readOnly={!props.admin}
									/>
								</div>
								<div>
									<FormLabel htmlFor="guest_mobile">
										Guest mobile number
									</FormLabel>
									<FormInput
										value={(guest.contact || { mobile: '' }).mobile}
										onChange={(e) =>
											onChange('contact', 'mobile', e.target.value)
										}
										readOnly={!props.admin}
									/>
								</div>
							</>
					}
				</section>
			</FormRow>
			<FormRow>
				<FormLabel htmlFor="guest_address">Guest address</FormLabel>
				<FormInputTextArea
					widthtype="full"
					value={(guest.contact || { address: '' }).address}
					onChange={(e) =>
						onChange('contact', 'address', e.target.value)
					}
					readOnly={!props.admin}
				/>
			</FormRow>
			<FormRow>
				<section className="booking-list_side-by-side">
					<div>
						<FormLabel htmlFor="guest_country">Country</FormLabel>
						<FormInput
							value={(guest.contact || { country: '' }).country}
							onChange={(e) =>
								onChange('contact', 'country', e.target.value)
							}
							readOnly={!props.admin}
						/>
					</div>
					<div>
						<FormLabel htmlFor="guest_postcode">Postcode</FormLabel>
						<FormInput
							widthtype="half"
							value={(guest.contact || { postcode: '' }).postcode}
							onChange={(e) =>
								onChange('contact', 'postcode', e.target.value)
							}
							readOnly={!props.admin}
						/>
					</div>
				</section>
			</FormRow>
			<section className="booking-list_side-by-side booking-list-side-by-side-guests">
				<div>
					<FormLabel htmlFor="guest_adults">Adults</FormLabel>
					<FormInput
						widthtype="narrow"
						value={guest.party.adults || 0}
						onChange={(e) =>
							onChange('party', 'adults', e.target.value)
						}
						readOnly={!props.admin}
					/>
				</div>
				<div>
					<FormLabel htmlFor="guest_children">Children</FormLabel>
					<FormInput
						widthtype="narrow"
						value={guest.party.children || 0}
						onChange={(e) =>
							onChange('party', 'children', e.target.value)
						}
						readOnly={!props.admin}
					/>
				</div>
				<div>
					<FormLabel htmlFor="guest_infants">Infants</FormLabel>
					<FormInput
						widthtype="narrow"
						value={guest.party.infants || 0}
						onChange={(e) =>
							onChange('party', 'infants', e.target.value)
						}
						readOnly={!props.admin}
					/>
				</div>
			</section>
		</div>
	);
};
